import { Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MmuAnnouncementService } from '../mmu-announcement-service/mmu-announcement.service';
import { MmuAnnouncement } from '../models/announcement';


@Component({
  selector: 'mmu-announcement-banner',
  template: `
    <ng-container *ngFor="let announcement of (announcements$ | async)">
      <mui-banner
        *ngIf="announcement && shouldShowAnnouncement(announcement)"
        class="mui-app-frame__banner banner--announcement"
        [class.undismissable]="!announcement.config.dismissible"
        [color]="announcement.config.color ?? 'info'"
        [icon]="announcement.config.icon"
        [dismissButtonLabel]="'unsupportedBrowserBanner.closeBtn' | translate"
        (dismiss)="announcement.config.dismissible ? dismiss(announcement.config.id) : null"
      >
        <ng-container [ngTemplateOutlet]="announcement.template"></ng-container>
      </mui-banner>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .banner--announcement ::ng-deep a {
        color: inherit;
        cursor: pointer;
        font-weight: 500;
        text-decoration: underline;
      }

      .banner--announcement.undismissable ::ng-deep .mui-banner_close {
        visibility: hidden;
        user-select: none;
      }
    `
  ]
})
export class MmuAnnouncementComponent {
  delay?: Subscription;
  announcements$: Observable<MmuAnnouncement[]>;

  constructor(private announcementService: MmuAnnouncementService) {
    this.announcements$ = this.announcementService.announcements;
  }

  shouldShowAnnouncement(announcement: MmuAnnouncement): boolean {
    return announcement.config.display ?? false;
  }

  dismiss(id: string): void {
    this.announcementService.dismissAnnouncement(id);
  }
}
